export enum RecruitmentStatusType {
	CANCELLED = "CANCELLED",
	HIRED = "HIRED",
	IN_REVIEW = "IN_REVIEW",
}
